import { useEffect } from "react";
import { useListView } from "../../core/ListViewProvider";
import { FailedEventModalHeader } from "./FailedEventModalHeader";

const FailedEventModal = () => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const { itemIdForUpdate } = useListView();

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-650px">
          <div className="modal-content">
            <FailedEventModalHeader />
            <div className="modal-body scroll-y mx-5 mx-xl-15 my-7">
              <div>
                <label className="fw-bold fs-6 mb-2">AMOUNT</label>
                <div>{itemIdForUpdate?.amount}</div>
              </div>

              <div>
                <label className="fw-bold fs-6 mb-2">EVENT ID</label>
                <div>{itemIdForUpdate?.eventId}</div>
              </div>

              <div>
                <label className="fw-bold fs-6 mb-2">RESOURCE ID</label>
                <div>{itemIdForUpdate?.resourceId}</div>
              </div>

              <div>
                <label className="fw-bold fs-6 mb-2">USER ID</label>
                <div>{itemIdForUpdate?.userId}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export { FailedEventModal };
